module.exports = __webpack_public_path__ + "media/images/front/pc/routable/icon01-9b9e24f34cfdf536e8578cbf92266b33.png";